import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import '@fortawesome/fontawesome-free/css/all.css';
import VueClipboard from 'vue-clipboard2';
import Vuetify from 'vuetify';
import Vuex from 'vuex';
import store from './store';
import VueLogger from 'vuejs-logger';
import Toasted from 'vue-toasted';
const options = {
  isEnabled: true,
  logLevel: 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: false,
  separator: '|',
  showConsoleColors: true,
};
Vue.config.productionTip = false;
Vue.use(VueLogger, options);
Vue.use(Toasted);
Vue.use(Vuetify, {
  iconfont: 'fa',
});
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);
Vue.use(Vuex);
new Vue({
  vuetify,
  store,
  render: h => h(App),
}).$mount('#app');
